<template>
  <nav v-if="items.length" :aria-label="i18n(translations.breadcrumb)">
    <ol
      class="m-0 flex list-none items-center py-8 md:py-12"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <template v-for="(item, index) in items" :key="item.title">
        <li
          v-if="(items.length > 1 && index !== 0) || items.length === 1"
          class="text-action-default-low caption-bold flex py-8 md:body-2-bold"
          itemprop="itemListElement"
          itemscope
          itemtype="http://schema.org/ListItem"
        >
          <RevLink
            class="text-action-default-low flex items-center whitespace-nowrap"
            itemprop="item"
            :to="item.link"
            :tracking="item.tracking"
            :underlined="false"
            @click="emit('click-breadcrumb', item.title)"
          >
            <span class="truncate" itemprop="name">
              {{ item.title }}
            </span>
          </RevLink>

          <IconChevronRight
            v-if="index !== 0 && index !== items.length - 1"
            aria-hidden="true"
            class="inline-block"
            size="16"
          />

          <meta :content="`${index}`" itemprop="position" />
        </li>
      </template>
    </ol>
  </nav>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { isEmpty } from '@backmarket/utils/object/isEmpty'
import { RevLink } from '@ds/components/Link'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import translations from './Breadcrumb.translations'

const props = defineProps<{
  breads: { label: string; url: string }[]
  trackingZone: string
}>()

const i18n = useI18n()

const emit = defineEmits<{
  (e: 'click-breadcrumb', title: string): void
}>()

const items = computed(() => {
  if (isEmpty(props.breads)) {
    return []
  }

  return props.breads.map((bread, index) => {
    const link = {
      title: bread.label,
      link: bread.url,
      tracking: {
        zone: props.trackingZone,
        value: 'breadcrumb',
        name: bread.label,
        /**
         * We're mapping the position to the old breadcrumb structure
         * because we don't have the Home link in the new breadcrumb
         * anymore, to keep the same position for the same links
         * in the tracking.
         *
         * If we have only one link, we want to set the position to 0
         * to keep the same position for the same links in the tracking.
         */
        position: `breadcrumb_${index === 0 ? 0 : index + 1}`,
      },
    }

    return link
  })
})
</script>
